module.exports = __webpack_public_path__ + "static/media/coil_discharge.313fb7a7.mp3";